export default function CustomWidth({ children, className = '' }) {
    return (
        <main
            className={`flex-1 lg:ml-[10%] lg:mr-[10%] md:ml-[15%] md:mr-[15%] mobile:ml-0 mobile:mr-0 ${className}`}
        >
            {children}
        </main>
    );
}
